import { Link } from "react-router-dom";

export const GlobeMark = ({ className = "h-9 w-9" }) => (
  <img src="/assets/ega-globe.png" alt="" aria-hidden="true" className={`${className} object-contain`} />
);

export const Logo = ({ onClick, testId = "nav-logo-link" }) => (
  <Link to="/" onClick={onClick} data-testid={testId} aria-label="Emerald Global Advisory home" className="block shrink-0 w-[176px] sm:w-[206px]">
    <img data-testid={`${testId}-image`} src="/assets/ega-logo-horizontal-transparent.png" width="879" height="286" alt="Emerald Global Advisory" className="w-full h-auto object-contain" />
  </Link>
);
